<template>
  <div>
    <el-container>
      <el-aside style="width: 200px;">
        <Menu activeName="3-1"></Menu>
      </el-aside>
      <el-main
        style="display: flex;flex: 1;flex-direction: column;align-items: center;justify-content: center;padding-top: 50px;height: 100vh;">
        <div style="display: flex;flex-direction: row;justify-content: space-between;width: 90%;">
          <el-dropdown split-button type="primary" :split-button="true" @command="dropdownClick">
            批量操作
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="batch-delete">删除</el-dropdown-item>
              <el-dropdown-item command="export">导出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-form :inline="true" :model="searchParams" class="demo-form-inline" style="margin-left: 20px;">
            <el-form-item>
              <el-input v-model="searchParams.name" placeholder="请输入路线名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-date-picker v-model="dateTimeRange" type="datetimerange" :picker-options="pickerOptions"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-select clearable v-model="searchParams.user_id" placeholder="请选择业务员">
                <el-option v-for="item in userList" :key="item.id" :label="item.username" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getTeamRouteList">查询</el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-table border v-loading="loading" :data="list" height="300" style="width: 90%;margin: 0 auto;"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column fixed prop="name" label="路线名称" width="180">
          </el-table-column>
          <el-table-column label="业务员" width="200">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top" v-if="scope.row.username">
                <p>姓名: {{ scope.row.username }}</p>
                <p>手机号: {{ scope.row.phone }}</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag size="medium">{{ scope.row.username }}</el-tag>
                </div>
              </el-popover>
              <el-link style="margin-top: 10px;" type="primary" @click="setRouteUser(scope.row)">指定业务员</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="distance" label="预计路程" width="100">
          </el-table-column>
          <el-table-column prop="duration" label="预计耗时" width="100">
          </el-table-column>
          <el-table-column label="路线策略" width="260">
            <template slot-scope="scope">
              <el-tag size="small" effect="dark" v-if="scope.row.mode">{{ scope.row.mode }}</el-tag>
              <el-tag size="small" type="success" effect="dark" v-if="scope.row.strategy">{{ scope.row.strategy }}
              </el-tag>
              <el-tag size="small" type="warning" effect="dark" v-if="scope.row.route_type">{{ scope.row.route_type }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建日期" width="180">
          </el-table-column>
          <el-table-column prop="remarks" label="备注" width="180">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="220">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="showRouteDetails(scope.row)">查看</el-button>
              <el-button type="text" size="small" @click="showRouteMap(scope.row)">地图</el-button>
              <el-popconfirm title="是否移除该路线？" style="margin-left: 10px;" @confirm="deleteRoute(scope.row)">
                <el-button slot="reference" type="text" size="small">删除</el-button>
              </el-popconfirm>
              <el-dropdown @command="handleCommand" style="margin-left: 10px;">
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
<!--                  <el-dropdown-item :command="commandValue('copy', scope.row)">复制</el-dropdown-item>-->
                  <el-dropdown-item :command="commandValue('export', scope.row)">导出</el-dropdown-item>
                  <el-dropdown-item :command="commandValue('remarks', scope.row)">备注</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 30px;" background layout="total,sizes,prev, pager, next,jumper"
          :page-sizes="[10, 20, 50, 100]" :page-size.sync="searchParams.limit" :current-page.sync="searchParams.page"
          @size-change="getTeamRouteList" @current-change="getTeamRouteList" :total="total">
        </el-pagination>

        <!-- 查看路线详情信息start -->
        <el-dialog :title="details.name" width="70%" :visible.sync="routeDetailsDialogStatus">
          <div style="display: flex;width: 100%;height: 60vh;flex-direction: column;align-items: center;">
            <div style="width: 90%;margin-bottom: 20px;display: flex;flex-direction: row;align-items: center;">
              <div>
                <el-tag v-if="details.delivery_status === 0" type="info">待配送</el-tag>
                <el-tag v-if="details.delivery_status === 1" type="warning">配送中</el-tag>
                <el-tag v-if="details.delivery_status === 2" type="success">配送完成</el-tag>
                <el-tag v-if="details.delivery_status === 3" type="danger">停止配送</el-tag>
              </div>
              <div style="width: 80%;margin-left: 20px;">
                <el-progress :text-inside="true" :stroke-width="26" :percentage="details.progress_percentage"
                  v-if="details.delivery_status === 0"></el-progress>
                <el-progress :text-inside="true" :stroke-width="26" :percentage="details.progress_percentage"
                  status="warning" v-if="details.delivery_status === 1"></el-progress>
                <el-progress :text-inside="true" :stroke-width="26" :percentage="details.progress_percentage"
                  status="success" v-if="details.delivery_status === 2"></el-progress>
                <el-progress :text-inside="true" :stroke-width="26" :percentage="details.progress_percentage"
                  status="exception" v-if="details.delivery_status === 3"></el-progress>
              </div>
            </div>
            <el-table border :data="placeList" height="500" style="width: 90%;margin: 0 auto;"
              @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column fixed label="地点名称" width="180">
                <template slot-scope="scope">
                  <div style="color: #67C23A;font-weight: 600;" v-if="scope.row.state === 1 && scope.row.sort > 0">
                    {{ scope.row.name }}(已完成)
                  </div>
                  <div style="font-weight: 600;" v-else-if="scope.row.state === 0 && scope.row.sort > 0">
                    {{ scope.row.sort }}、{{ scope.row.name }}
                  </div>
                  <div style="color: #E6A23C;font-weight: 600;" v-else-if="scope.row.sort === 0">
                    {{ scope.row.name }}(还未规划)
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="详细地址" width="280">
              </el-table-column>
              <el-table-column label="客户信息" width="200">
                <template slot-scope="scope" v-if="scope.row.phone_name">
                  <el-popover trigger="hover" placement="top">
                    <p>姓名: {{ scope.row.phone_name }}</p>
                    <p>手机号: {{ scope.row.phone }}</p>
                    <div slot="reference" class="name-wrapper">
                      <el-tag size="medium">{{ scope.row.phone_name }}</el-tag>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="remarks" label="备注" width="200">
              </el-table-column>
              <el-table-column prop="create_time" label="创建日期" width="180">
              </el-table-column>
              <el-table-column prop="arrival_time" label="完成日期" width="180">
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="showRoutePlacePhotos(scope.row)">签收照片</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-dialog>
        <!-- 查看路线详情信息end -->
        <el-image style="position: fixed;bottom: 0;right: 0;width: 0;height: 0;" ref="preview" :preview-src-list="photos"></el-image>

        <!-- 设置业务员start -->
        <el-dialog :title="dialogSetUser.dialogTitle" :visible.sync="dialogSetUser.dialogState" width="30%">
          <el-select v-model="routeUserId" placeholder="请选择此路线业务员">
            <el-option v-for="item in userList" :key="item.id" :label="item.username" :value="item.id">
            </el-option>
          </el-select>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancelSetRouteUser">取 消</el-button>
            <el-button type="primary" @click="confirmSetRouteUser">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 设置业务员end -->

        <!-- 备注start -->
        <el-dialog :title="dialogRemarks.dialogTitle" :visible.sync="dialogRemarks.dialogState" width="30%">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="remarksForm.remarks">
          </el-input>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancelRemarks">取 消</el-button>
            <el-button type="primary" @click="confirmRemarks">保 存</el-button>
          </span>
        </el-dialog>
        <!-- 备注end -->

      </el-main>
    </el-container>
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue'
import {
  GetRoutePlace,
  GetTeamRouteList,
  SetRouteUser,
  SaveRouteRemarks,
  DeleteRoute,
  BatchDeleteRoute,
  ExportRoute,
  BatchExportRoute, GetRoutePlacePhotos
} from '../api/route.js'
import { GetTeamUser } from '../api/personnel.js'

export default {
  name: 'RouteList',
  components: { Menu },
  data() {
    return {
      routeUserId: '',
      searchParams: {
        limit: 10,
        page: 1,
      },
      dialogRemarks: {
        dialogState: false,
        dialogTitle: '路线备注'
      },
      dialogSetUser: {
        dialogState: false,
        dialogTitle: '指定业务员'
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      setRouteUserForm: {},
      remarksForm: {},
      details: {},// 展示的路线详情信息
      placeSearchParams: {}, // 路线地点列表搜索条件
      routeDetailsDialogStatus: false,
      loading: true,
      userList: [],
      selectIdArr: [],// 已选中路线id集合
      list: [], // 路线列表
      placeList: [], // 路线的地点列表
      photos:[], // 路线地点的签收照片集合
      total: 0, // 路线总数
      dateTimeRange: [],
    }
  },
  mounted() {
    this.getTeamUser()
    this.getTeamRouteList()
  },
  methods: {
    getTeamRouteList() {
      let that = this
      that.formatDateTime()
      GetTeamRouteList(that.searchParams).then(res => {
        that.loading = false
        if (res.code === 200) {
          that.list = res.data.list
          that.total = res.data.total
        } else {
          this.$notify({
            type: 'error',
            message: res.message
          })
        }
      })
    },
    commandValue(command, row) {
      return {
        command: command,
        row: row
      }
    },
    handleCommand(e) {
      console.log(e)
      switch (e.command) {
        case "copy":
          this.showPlaceUpdateForm(e.row)
          break
        case "export":
          this.routeExport(e.row)
          break
        case "remarks":
          this.remarksForm.route_id = e.row.id
          this.dialogRemarks.dialogState = true
          this.dialogRemarks.dialogTitle = "编辑路线(" + e.row.name + ")备注"
          break
      }
    },
    getRoutePlaceList(id) {
      let that = this
      GetRoutePlace({ route_id: id }).then(res => {
        if (res.code === 200) {
          that.placeList = res.data.list
        }
      })
    },
    routeExport(item) {
      let params = { id: item.id }
      ExportRoute(params).then(res => {
        if (res.code === 200) {
          this.$notify({
            type: 'success',
            message: '导出成功',
            onClose: function () {
              window.open(res.data.link)
            }
          })
        } else {
          this.$notify({
            type: 'error',
            message: res.message
          })
        }
      })
    },
    showRouteDetails(item) {
      this.details = item
      this.getRoutePlaceList(item.id)
      this.routeDetailsDialogStatus = true
    },
    showPlaceUpdateForm(item) {
      this.$router.push({ name: 'plan', query: { 'id': item.id } })
    },
    showRouteMap(item) {
      if(item.distance == '') {
        this.$notify({
          title: '警告',
          message: '还未规划的路线无法查看地图',
          type: 'warning'
        });
        return false;
      }
      this.$router.push({ name: 'route', params: { 'id': item.id } })
    },
    getTeamUser() {
      GetTeamUser().then(res => {
        if (res.code === 200) {
          this.userList = res.data.list
        }
      })
    },
    showRoutePlacePhotos(item){
      let that = this
      let params = {
        id:item.id
      }
      if (item.state == 0 ) {
        this.$notify({
          title: '提示',
          message: '地点还没有签收',
          type: 'warning'
        });
        return false;
      }
      GetRoutePlacePhotos(params).then(res=>{
        if(res.code == 200) {
          if(res.data == null || res.data.length == 0) {
            this.$notify({
              title: '提示',
              message: '此地点没有签收图片',
              type: 'warning'
            });
          } else {
            this.photos = res.data
            setTimeout(function () {
              that.$refs.preview.clickHandler()
            },500)
          }
        } else {
          this.$notify({
            title: '错误',
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    setRouteUser(item) {
      if (item.user_id) {
        this.setRouteUserForm.user_id = item.user_id
        this.routeUserId = item.user_id
      }
      this.setRouteUserForm.route_id = item.id
      this.dialogSetUser.dialogTitle = '指定(' + item.name + ')业务员'
      this.dialogSetUser.dialogState = true
    },
    cancelRemarks() {
      this.dialogRemarks.dialogState = false
      this.remarksForm.remarks = ''
      this.remarksForm.route_id = null
    },
    confirmRemarks() {
      let that = this
      this.setRouteUserForm.user_id = this.routeUserId
      SaveRouteRemarks(this.remarksForm).then(res => {
        if (res.code === 200) {
          this.dialogRemarks.dialogState = false
          this.setRouteUserForm.remarks = ''
          this.setRouteUserForm.route_id = null
          this.getTeamRouteList()
          this.$notify({
            type: 'success',
            message: '保存备注成功'
          })
        } else {
          this.$notify({
            type: 'error',
            message: res.message
          })
        }
      })
    },
    cancelSetRouteUser() {
      this.dialogSetUser.dialogState = false
      this.setRouteUserForm.user_id = ''
      this.setRouteUserForm.route_id = ''
    },
    confirmSetRouteUser() {
      let that = this
      this.setRouteUserForm.user_id = this.routeUserId
      SetRouteUser(this.setRouteUserForm).then(res => {
        if (res.code === 200) {
          this.dialogSetUser.dialogState = false
          this.setRouteUserForm.user_id = ''
          this.setRouteUserForm.route_id = ''
          this.getTeamRouteList()
          this.$notify({
            type: 'success',
            message: '指定业务员成功'
          })
        } else {
          this.$notify({
            type: 'error',
            message: res.message
          })
        }
      })
    },
    deleteRoute(item) {
      let that = this
      DeleteRoute({ route_id: item.id }).then(res => {
        if (res.code === 200) {
          that.getTeamRouteList()
          that.$notify({
            type: 'success',
            message: '删除' + item.name + '成功'
          })
        } else {
          that.$notify({
            type: 'error',
            message: res.message
          })
        }
      })
    },
    handleSelectionChange(e) {
      let idArr = []
      if (e.length > 0) {
        for (let i = 0; i < e.length; i++) {
          idArr.push(e[i].id)
        }
      }
      this.selectIdArr = idArr
    },
    dropdownClick(command) {
      if (command === 'batch-delete') {
        this.batchDeleteRoute()
      } else if (command == 'export') {
        this.batchExportRoute()
      }
    },
    batchExportRoute(){
      let that = this
      if (this.selectIdArr.length <= 0) {
        that.$notify({
          type: 'warning',
          title:'警告',
          message: '请选择要导出的路线'
        })
        return false;
      }
      let ids = this.selectIdArr.join(",")
      let params = {
        ids:ids
      }
      BatchExportRoute(params).then(res=>{
        if(res.code==200){
          this.$notify({
            type: 'success',
            message: res.message
          })
          let links = res.data.links
          for (let i =0;i<links.length;i++){
            window.open(links[i])
          }
        } else {
          this.$notify({
            type: 'error',
            title:'错误',
            message: res.message
          })
        }
      })
    },
    batchDeleteRoute() {
      let that = this
      if (this.selectIdArr.length <= 0) {
        that.$notify({
          type: 'warning',
          title:'警告',
          message: '请先选择要删除的路线'
        })
        return
      }
      this.$confirm('批量删除确定', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = this.selectIdArr.join(',')
        BatchDeleteRoute({ ids: ids }).then(res => {
          if (res.code === 200) {
            that.getTeamRouteList()
            that.$notify({
              type: 'success',
              message: '删除成功'
            })
          } else {
            that.$notify({
              type: 'error',
              message: res.message
            })
          }
        })
      })

    },
    checkTime(i) {
      if (i < 10) {
        console.log(i)
        i = '0' + i
      }
      return i
    },
    getTime(data) {
      return data.getFullYear() + '-' +
        this.checkTime(data.getMonth() + 1) + '-' +
        this.checkTime(data.getDate()) + ' ' +
        this.checkTime(data.getHours()) + ':' +
        this.checkTime(data.getMinutes()) + ':' +
        this.checkTime(data.getSeconds())
    },
    formatDateTime() {
      let dateTimeRange = this.dateTimeRange
      if (dateTimeRange !== null && dateTimeRange.length === 2) {
        this.searchParams.start_time = this.getTime(dateTimeRange[0])
        this.searchParams.end_time = this.getTime(dateTimeRange[1])
      } else {
        this.searchParams.start_time = ''
        this.searchParams.end_time = ''
      }
    },

  }
}
</script>

<style scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
  font-size: 12px;
  font-weight: bold;
}

.el-icon-arrow-down {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/RouteList.vue